import { Box, Typography } from "@mui/material";
import moment from "moment";

const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const CalendarHeader = ({ date, view }) => {
  const start = moment(date).startOf("week");

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns:
          view === "month" ? "repeat(7, 1fr)" : "60px repeat(7, 1fr)",
        borderBottom: "1px solid #e5e7eb",
        background: "#f1f5f9",
        textTransform: "uppercase"
      }}
    >
      {view !== "month" && <Box />}

      {days.map((day, i) => {
        const d = start.clone().add(i, "days");

        return (
          <Box
            key={day}
            sx={{
              textAlign: "center",
              py: 1,
              fontSize: 12,
              color: "#6b7280",
              bgcolor:"#f1f5f9"
            }}
          >
            <Typography variant="subtitle2">{day}</Typography>
            <Typography variant="subtitle2">
              {view === "month" ? null : d.format("D")}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default CalendarHeader;
